// 入力画面のレイアウト(パネル並び・列状態・基本情報項目)の
// ローカル退避/復元とサーバ側レイアウトの登録・削除・呼び出しをまとめる。
// 加工指示・品番マスタで同一実装のため共有する。
export function createLayoutStorageService(deps) {
    const {
        isEmpty,
        DeepCopy,
        Getstorage,
        Savestorage,
        G_id,
        fnc,
        AGRef,
        dispatch,
        addentrylayout,
        setentrylayout,
        setentrystartup,
        getCorpkey,
        getAccount,
        getFormId,
        getController,
        getSubkey,
        getPanels,
        getGridList,
        getTextFields,
        getColumnInfo,
        getMainLayout,
        getMainPreLayout,
        getMainInitLayout,
        setPanels,
        setColumns,
        setTextFieldsAll,
        setTextFields,
        tabletype,
        GridColApi,
        SetGridColDef,
        isEmptyPanel,
        normalizeDisplayFields,
        buildBaseFieldSet
    } = deps;

    // パネルの並び/表示状態をローカル退避から復元する。
    function RestorePanel(panel) {
        let paneldata = Getstorage(getCorpkey(), getAccount(), getFormId() + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setPanels(paneldata);
    }

    //レイアウト保持
    function LayoutSaveStorage() {
        // 再表示や戻る操作に備えて、列状態と表示パネルをローカルに退避
        const gridlist = getGridList();
        const formid = getFormId();
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), isEmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(getCorpkey(), getAccount(), fnc.current.statusKey(G_id.BASE, "", formid), getTextFields());
        //パネルの表示/非表示および並び
        Savestorage(getCorpkey(), getAccount(), formid + "panel", getPanels());
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        const panel = getPanels();
        const textfields = getTextFields();
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: getController(),
                subkey: getSubkey(),
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }

    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: getController(),
                subkey: getSubkey(),
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = getMainLayout().filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== getMainInitLayout())
                        dispatch(setentrystartup({
                            prelayout: getMainPreLayout(),
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }

    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: getController(),
                subkey: getSubkey(),
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    const gridlist = getGridList();
                    const columninfo = getColumnInfo();
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        const normalizedColumns = normalizeDisplayFields(data.columns);
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), normalizedColumns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setPanels(data.panels);
                    const normalizedColumns = normalizeDisplayFields(data.columns);
                    const baseFields = buildBaseFieldSet(columninfo, normalizedColumns);
                    setTextFieldsAll(baseFields.all);
                    setTextFields(baseFields.visible);
                    setColumns(normalizedColumns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    return {
        RestorePanel,
        LayoutSaveStorage,
        SaveLayout,
        DeleteLayout,
        CallLayout
    };
}
